import {
  ClipboardDocumentCheckIcon,
  DocumentTextIcon,
  FolderIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export const theme = {
  brand: {
    name: 'Rapid Build',
    shortName: 'Rapid Build',
    mark: 'Rapid Circle',
    supportEmail: 'support@rapidcircle.com'
  },
  // `key` maps to an i18n key under `nav.*`; the visible label is translated.
  nav: [
    { key: 'platform', href: '#platform' }
  ],
  // `key` maps to an i18n key under `features.items.*`; title/description are translated.
  features: [
    { icon: DocumentTextIcon, key: 'generate' },
    { icon: ClipboardDocumentCheckIcon, key: 'wizard' },
    { icon: FolderIcon, key: 'library' }
  ] satisfies Array<{ icon: IconComponent; key: string }>
} as const;
